'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dFeatures$0024 from "./presto.types$-Features$.js";
var $p;
/** @constructor */
function $c_Lpresto_EnvelopeDetailPage(id) {
  this.wL = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$L0;
  this.wL = id;
}
export { $c_Lpresto_EnvelopeDetailPage as $c_Lpresto_EnvelopeDetailPage };
$p = $c_Lpresto_EnvelopeDetailPage.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_EnvelopeDetailPage;
/** @constructor */
function $h_Lpresto_EnvelopeDetailPage() {
}
export { $h_Lpresto_EnvelopeDetailPage as $h_Lpresto_EnvelopeDetailPage };
$h_Lpresto_EnvelopeDetailPage.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_EnvelopeDetailPage)) {
    var this$1 = this.wL;
    var b = x$0.wL;
    return ((this$1.e === b.e) && (this$1.f === b.f));
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 1;
});
$p.s = (function() {
  return "EnvelopeDetailPage";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.wL;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.dw = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some($j_presto$002etypes$0024$002dFeatures$0024.$m_Lpresto_types$Features$().E4);
});
function $isArrayOf_Lpresto_EnvelopeDetailPage(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ib)));
}
export { $isArrayOf_Lpresto_EnvelopeDetailPage as $isArrayOf_Lpresto_EnvelopeDetailPage };
var $d_Lpresto_EnvelopeDetailPage = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_EnvelopeDetailPage, "presto.EnvelopeDetailPage", ({
  ib: 1,
  a2: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_EnvelopeDetailPage as $d_Lpresto_EnvelopeDetailPage };
//# sourceMappingURL=presto.-Envelope-Detail-Page.js.map
